bq.toggleItems = function(element) {
  this.$element  = $(element);
  this.lines = $('.collapse', element);
  this.collapseButton = $('.collapse-all', element);
  this.expandButton = $('.expand-all', element);
  this.buttonsContainer = $('.line-items-toggle', element);
  this.linesVisibility = {};
  this.mainVisibility = null;
  this.isNewDesign = false;
};

bq.toggleItems.prototype = {

  init: function() {
    var $this = this;
    $this.isNewDesign = parseInt($this.$element.data('is-new-design'), 10) === 1;

    $this.fillLinesStatuses();
    $this.syncAllRowChevrons();

    $this.collapseButton.on('click', {thiz: $this}, $this.collapseLines);
    $this.expandButton.on('click', {thiz: $this}, $this.expandLines);

    $('.view-more-details', $this.$element).each(function() {
      $('.more, .less', this).on('click', {parentContainer: this}, $this.toggleDetails);
    });

    $('.toggle-item-link', $this.$element).each(function() {
      $(this).on('click', {target: $(this).data('toggle-target'), thiz: $this}, $this.toggleOneLine)
    });
  },

  toggleOneLine: function(e) {
    var target = e.data.target;
    var $this = e.data.thiz;

    $(target).toggle();

    $this.fillLinesStatuses();
    $this.updateRowChevron(this);
  },

  toggleDetails: function(e) {
    var parentContainer = e.data.parentContainer;

    $(parentContainer).prev('.item-options-container').toggleClass('hidden');
    $('a', parentContainer).toggleClass('hidden');
  },

  collapseLines: function(e) {
    var $this = e.data.thiz;

    $this.lines.hide();

    $this.toggleArrowIcon('up', 'down');
  },

  expandLines: function(e) {
    var $this = e.data.thiz;

    $this.lines.show();

    $this.toggleArrowIcon('down', 'up');
  },

  toggleArrowIcon: function(from, to) {
    $('span[data-bq="collapse"]', this.$element).each(function(){
      if ($(this).hasClass('fa-angle-double-' + from)) {
        $(this).removeClass('fa-angle-double-' + from).addClass('fa-angle-double-' + to);
      }
    });

    $('a', this.buttonsContainer).toggleClass('hidden');
    this.fillLinesStatuses();
    this.syncAllRowChevrons();
  },

  fillLinesStatuses: function() {
    var $this = this;

    $this.lines.each(function() {
      $this.linesVisibility[$(this).attr('id')] = $(this).is(':visible') ? 'visible' : 'invisible';
    });

    $this.checkAllItemsTheSame();
    $this.updateRowColors();
    $this.updateLastRowClass();
  },

  checkAllItemsTheSame: function() {
    var $this = this;

    var allLinesTheSame = Object.keys($this.linesVisibility).every(function(line) {
      return $this.linesVisibility[line] === $this.linesVisibility[Object.keys($this.linesVisibility)[0]];
    });

    if (allLinesTheSame) {
      $this.mainVisibility = $this.linesVisibility[Object.keys($this.linesVisibility)[0]];

      $this.showProperButton();
    }
  },

  showProperButton: function() {
    var properButton = this.mainVisibility === 'visible' ? this.collapseButton : this.expandButton;

    if (properButton.is(':visible')) return;

    $('a', this.buttonsContainer).toggleClass('hidden');
  },

  updateRowColors: function() {
    if (!this.isNewDesign) {
      return;
    }

    this.$element.find('tbody tr.doc-item-row').each(function(index, row) {
      var trStripedClass = index % 2 === 0 ? 'tr-striped-color-grey' : 'tr-striped-color-white';
      row.style.backgroundColor = '';
      $(row).removeClass('tr-striped-color-grey', 'tr-striped-color-white');
      $(row).addClass(trStripedClass);
    });
  },

  updateRowChevron: function(toggleLink) {
    if (!this.isNewDesign || !toggleLink) {
      return;
    }

    var targetSelector = toggleLink.getAttribute('data-toggle-target');
    var targetRow = targetSelector ? this.$element.find(targetSelector).get(0) : null;
    var chevron = toggleLink.querySelector('[data-line-chevron]');

    if (!targetRow || !chevron) {
      return;
    }

    var isExpanded = window.getComputedStyle(targetRow).display !== 'none';

    if (isExpanded) {
      chevron.classList.remove('fa-caret-down', 'text-muted');
      chevron.classList.add('fa-caret-up', 'text-primary');
      return;
    }

    chevron.classList.remove('fa-caret-up', 'text-primary');
    chevron.classList.add('fa-caret-down', 'text-muted');
  },

  syncAllRowChevrons: function() {
    var $this = this;

    if (!$this.isNewDesign) {
      return;
    }

    $this.$element.find('.toggle-item-link').each(function() {
      $this.updateRowChevron(this);
    });
  },

  updateLastRowClass: function() {
    this.$element.find('[data-bq-table-last-row]').each(function() {
      bq.global.updateTableLastRowClass(this, $(this).data('last-row-class'));
    });
  }
};

var toggleItemsold = $.fn.toggleItems;

$.fn.toggleItems = function () {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.toggleItems');
    var options = $.extend({}, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.toggleItems', (data = new bq.toggleItems(this, options))); }
    data.init();
  });
};

$.fn.toggleItems.Constructor = bq.toggleItems;

$.fn.toggleItems.noConflict = function () {
  $.fn.toggleItems = toggleItemsold;
  return this;
};

bq.global.toggleLinesInit = function() {
  $('.grid-collapsable-items').each(function() {
    var el = $(this);
    if(el.data('bq.toggleItems')) { return; }
    el.toggleItems(el.data());
  });
};

bq.global.updateTableLastRowClass = function(tableElement, rowClassName) {
  var $table = $(tableElement);
  var targetClass = rowClassName || $table.data('last-row-class') || 'last-row';
  var $rows = $table.find('tbody tr');
  var $targetRow = $rows.filter(':visible').last();

  if (!$rows.length) {
    return;
  }

  if (!$targetRow.length) {
    $targetRow = $rows.last();
  }

  $rows.removeClass(targetClass);
  $targetRow.addClass(targetClass);
};

bq.global.toggleLineWithLastRow = function(toggleLink, rowClassName) {
  var $toggleLink = $(toggleLink);
  var targetSelector = $toggleLink.data('toggle-target');
  var targetClass = rowClassName || $toggleLink.data('last-row-class') || 'last-row';

  if (!targetSelector) {
    return false;
  }

  var $detailRow = $(targetSelector);
  $detailRow.toggle();
  bq.global.updateTableLastRowClass($toggleLink.closest('table'), targetClass);

  return false;
};

bq.global.toggleLineRowsWithLastRowInit = function() {
  $('[data-bq="toggle-line-row"]').each(function() {
    var $toggleLink = $(this);

    if ($toggleLink.data('bq.toggleLineRowWithClass')) {
      return;
    }

    $toggleLink.data('bq.toggleLineRowWithClass', true);
    $toggleLink.on('click', function(e) {
      e.preventDefault();
      bq.global.toggleLineWithLastRow(this);
    });
  });

  $('[data-bq-table-last-row]').each(function() {
    bq.global.updateTableLastRowClass(this, $(this).data('last-row-class'));
  });
};

bq.init.push(bq.global.toggleLinesInit);
bq.init.push(bq.global.toggleLineRowsWithLastRowInit);